import { BaseEntity } from '../../models';
import { formaPagamentoSituacaoAtiva } from './forma-pagamento-situacao';

export class FormaPagamento implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    situacao: number;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    constructor() {
        this.situacao = formaPagamentoSituacaoAtiva.id;
    }
}
